import React from 'react';
import { SingleFieldSection } from '../../../modules/unsw-modals';
import { useCristal } from '../../../contexts/cristal';

const CristalScore = () => {
  const { score } = useCristal();
  return <SingleFieldSection label={'CriSTAL'} value={score.toString()} />;
};

export default CristalScore;
